import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import ProgressPage from "./ProgressPage";
import { ProgressCallback } from "../types/ProgressTypes";
import { useDevice } from "../../model/DeviceContext";

interface RefreshEntitiesPageProps {
    onComplete: () => void;
}

const RefreshEntitiesPage: React.FC<RefreshEntitiesPageProps> = ({
    onComplete,
}) => {
    const { t } = useTranslation();
    const { refreshSubscription } = useDevice();

    // Use useCallback to memoize the function and prevent re-renders
    const refreshEntitiesData = useCallback(async (callbacks: ProgressCallback) => {
        try {
            callbacks.onProgress(
                t("refresh_entities.progress.refreshing", "Odświeżanie listy podmiotów BDO..."),
                0
            );

            console.log('🔄 Refreshing BDO entities subscription...');

            // Call refreshSubscription and wait for it to complete
            await refreshSubscription();

            // Add small delay to ensure state update
            await new Promise(resolve => setTimeout(resolve, 100));

            callbacks.onProgress(
                t("refresh_entities.progress.complete", "Lista podmiotów BDO odświeżona"),
                100
            );

            console.log('✅ BDO entities refreshed successfully');

            // Add small delay before success callback (similar to UpdateCompanyPage)
            await new Promise(resolve => setTimeout(resolve, 100));

            callbacks.onSuccess(
                t("refresh_entities.success", "Lista podmiotów BDO została pomyślnie odświeżona")
            );

        } catch (error) {
            console.error('❌ Refresh entities error:', error);
            const errorMessage = error instanceof Error ? error.message : "Unknown error";
            callbacks.onError(
                t("refresh_entities.error.network", `Błąd odświeżania: ${errorMessage}`)
            );
        }
    }, [t, refreshSubscription]); // Add dependencies

    return (
        <ProgressPage
            fetchData={refreshEntitiesData}
            loadingMessage={t("refresh_entities.loading", "Odświeżanie listy podmiotów BDO...")}
            successMessage={t("refresh_entities.success", "Lista podmiotów BDO została pomyślnie odświeżona")}
            backTo="bdo-entities"
            autoReturnDelay={2000}
            onComplete={onComplete}
        />
    );
};

export default RefreshEntitiesPage;
